import { render, staticRenderFns } from "./PageDesign.vue?vue&type=template&id=25399d86&scoped=true"
import script from "./PageDesign.vue?vue&type=script&lang=js"
export * from "./PageDesign.vue?vue&type=script&lang=js"
import style0 from "./PageDesign.vue?vue&type=style&index=0&id=25399d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25399d86",
  null
  
)

export default component.exports